<div mat-dialog-title>
    <su-headline h="h3" skin="primary">{{ 'access_orderer.user.button_add' | translate }}</su-headline>
  </div>
  
  <div mat-dialog-content>
    <form [formGroup]="form">
      <formly-form
        [form]="form"
        [fields]="formFields"
        [model]="formModel"></formly-form>
    </form>
    <div *ngIf="data.endAccessOrderer">
      <p>
        {{ 'access_orderer.end.description' | translate }}
      </p>
    </div>
    <div *ngFor="let cid of costCenterSelection">
      <mat-checkbox [(ngModel)]="cid.selected">
         {{ cid.id }} - {{ cid.name }}
      </mat-checkbox>
    </div>
    <div [hidden]="hasCostCenterSelection">
      {{ 'access_orderer.dialog.no_costcenters_assignable' | translate }}
    </div>
  </div>
  <div mat-dialog-actions>
    <su-button
      skin="secondary"
      [label]="'shared.cancel' | translate"
      mat-dialog-close></su-button>

    <su-button
      skin="primary"
      [label]="'shared.save' | translate"
      [disabled]="!hasCostCenterSelection"
      (onClick)="submit()"></su-button>
  </div>
  
  <app-spinner-overlay [show]="isLoading"></app-spinner-overlay>